export default __webpack_public_path__ + "static/media/portada_PaulinaVillalobos_ENG.2c8c25d6.jpg";